import React, { useState, useEffect, useCallback } from 'react';

const COLORS = ['#378ADD','#1D9E75','#D85A30','#D4537E','#639922','#BA7517','#534AB7','#888780'];
function hashStr(s) { let h=0; for(let i=0;i<s.length;i++) h=(Math.imul(31,h)+s.charCodeAt(i))|0; return h; }
function getColor(ev, cals) {
  if(cals?.length){ const c=cals.find(c=>c.id===ev.calendarId); if(c?.backgroundColor) return c.backgroundColor; }
  return COLORS[Math.abs(hashStr(ev.id||ev.summary||''))%COLORS.length];
}
function fmtTime(ev) {
  if(ev.start?.date) return 'Tutto il giorno';
  return new Date(ev.start?.dateTime).toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'});
}
function fmtTimeRange(ev) {
  if(ev.start?.date) return 'Tutto il giorno';
  const s=new Date(ev.start?.dateTime), e=new Date(ev.end?.dateTime);
  return s.toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'})+' – '+e.toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'});
}
function isHoliday(date) {
  const m=date.getMonth()+1, d=date.getDate();
  return [[1,1],[1,6],[4,25],[5,1],[6,2],[8,15],[11,1],[12,8],[12,25],[12,26]].some(([hm,hd])=>hm===m&&hd===d)||date.getDay()===0;
}
function isSaturday(date) { return date.getDay()===6; }
function sameDay(a,b) { return a.getDate()===b.getDate()&&a.getMonth()===b.getMonth()&&a.getFullYear()===b.getFullYear(); }
function evDate(e) { return e.start?.date?new Date(e.start.date+'T00:00:00'):new Date(e.start?.dateTime); }

const lbl={display:'block',fontSize:10,fontWeight:600,color:'var(--text-muted)',marginBottom:3,textTransform:'uppercase',letterSpacing:'0.5px'};
const inp={width:'100%',padding:'6px 8px',borderRadius:5,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)',fontSize:12,boxSizing:'border-box'};

function EventoModal({evento,onClose,onSave,onDelete}) {
  const isEdit=!!evento?.id;
  const [form,setForm]=useState({summary:evento?.summary||'',date:evento?.date||new Date().toISOString().split('T')[0],startTime:evento?.startTime||'09:00',endTime:evento?.endTime||'10:00',location:evento?.location||'',description:evento?.description||''});
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  return (
    <div className="modal-backdrop">
      <div className="modal" style={{maxWidth:380}}>
        <div className="modal-header">
          <span className="modal-title" style={{fontSize:14}}>{isEdit?'Modifica evento':'Nuovo evento'}</span>
          <button className="btn btn-icon" onClick={onClose} style={{fontSize:16}}>×</button>
        </div>
        <div className="modal-body" style={{display:'flex',flexDirection:'column',gap:10}}>
          <div><label style={lbl}>Titolo *</label><input style={inp} value={form.summary} onChange={e=>set('summary',e.target.value)} placeholder="Titolo" autoFocus/></div>
          <div><label style={lbl}>Data</label><input style={inp} type="date" value={form.date} onChange={e=>set('date',e.target.value)}/></div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
            <div><label style={lbl}>Inizio</label><input style={inp} type="time" value={form.startTime} onChange={e=>set('startTime',e.target.value)}/></div>
            <div><label style={lbl}>Fine</label><input style={inp} type="time" value={form.endTime} onChange={e=>set('endTime',e.target.value)}/></div>
          </div>
          <div><label style={lbl}>Luogo</label><input style={inp} value={form.location} onChange={e=>set('location',e.target.value)} placeholder="Luogo"/></div>
          <div><label style={lbl}>Note</label><input style={inp} value={form.description} onChange={e=>set('description',e.target.value)} placeholder="Note"/></div>
        </div>
        <div className="modal-footer">
          {isEdit&&<button className="btn" style={{color:'var(--c-red)',borderColor:'var(--c-red)',marginRight:'auto',fontSize:12}} onClick={()=>onDelete(evento.id)}>🗑</button>}
          <button className="btn" style={{fontSize:12}} onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" style={{fontSize:12}} onClick={async()=>{if(!form.summary.trim())return;setSaving(true);await onSave({...form,id:evento?.id});setSaving(false);}} disabled={saving||!form.summary.trim()}>{saving?'…':isEdit?'Salva':'Crea'}</button>
        </div>
      </div>
    </div>
  );
}

function DayPanel({date,events,calendars,onClose,onNew,onEdit}) {
  const dayEvs=events.filter(e=>sameDay(evDate(e),date)).sort((a,b)=>evDate(a)-evDate(b));
  const label=date.toLocaleDateString('it-IT',{weekday:'long',day:'numeric',month:'long'});
  return (
    <div style={{borderTop:'1px solid var(--border)',background:'var(--bg)',flexShrink:0}}>
      <div style={{padding:'7px 10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <span style={{fontSize:11,fontWeight:600,color:isHoliday(date)?'var(--c-red)':'var(--text)',textTransform:'capitalize'}}>{label}</span>
        <div style={{display:'flex',gap:4}}>
          <button className="btn btn-primary btn-sm" style={{fontSize:10,padding:'2px 7px'}} onClick={onNew}>+ Evento</button>
          <button className="btn btn-sm" style={{fontSize:10,padding:'2px 6px'}} onClick={onClose}>×</button>
        </div>
      </div>
      <div style={{padding:'0 10px 10px',maxHeight:180,overflowY:'auto'}}>
        {dayEvs.length===0?(
          <div style={{textAlign:'center',padding:'12px 0',color:'var(--text-faint)',fontSize:11}}>
            Nessun evento — <span style={{color:'var(--accent)',cursor:'pointer'}} onClick={onNew}>Aggiungi</span>
          </div>
        ):dayEvs.map(e=>{
          const col=getColor(e,calendars);
          return (
            <div key={e.id} onClick={()=>onEdit(e)} style={{display:'flex',gap:7,padding:'5px 6px',borderRadius:5,marginBottom:3,cursor:'pointer',background:'var(--surface)',border:'1px solid var(--border)'}}>
              <div style={{width:3,borderRadius:2,background:col,flexShrink:0,alignSelf:'stretch'}}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,fontWeight:500,color:'var(--text)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{e.summary}</div>
                <div style={{fontSize:10,color:'var(--text-faint)',marginTop:1}}>{fmtTimeRange(e)}</div>
                {e.location&&<div style={{fontSize:10,color:'var(--text-faint)'}}>📍 {e.location}</div>}
              </div>
              <span style={{fontSize:10,color:'var(--text-faint)',alignSelf:'center'}}>✎</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const FILTERS=[
  {key:'7d', label:'7 giorni'},
  {key:'all', label:'Tutti'},
  {key:'past', label:'Passati'},
];

export default function GoogleCalendarWidget() {
  const [events,setEvents]=useState([]);
  const [allEvents,setAllEvents]=useState([]); // cache tutti gli eventi caricati
  const [calendars,setCalendars]=useState([]);
  const [loading,setLoading]=useState(true);
  const [connected,setConnected]=useState(false);
  const [expanded,setExpanded]=useState(true);
  const [currentDate,setCurrentDate]=useState(new Date());
  const [selectedDay,setSelectedDay]=useState(null);
  const [modal,setModal]=useState(null);
  const [toast,setToast]=useState(null);
  const [filter,setFilter]=useState('7d');

  const showToast=(msg,type='info')=>{setToast({msg,type});setTimeout(()=>setToast(null),3000);};

  const checkAuth=useCallback(async()=>{
    const r=await fetch('/api/gcal/status').then(r=>r.json()).catch(()=>({connected:false}));
    setConnected(r.connected); return r.connected;
  },[]);

  const loadCalendars=useCallback(async()=>{
    const r=await fetch('/api/gcal/calendars').then(r=>r.json()).catch(()=>({success:false}));
    if(r.success) setCalendars(r.data);
  },[]);

  // Carica eventi del mese corrente per il calendario
  const loadMonthEvents=useCallback(async()=>{
    setLoading(true);
    const year=currentDate.getFullYear(),month=currentDate.getMonth();
    const timeMin=new Date(year,month,1).toISOString();
    const timeMax=new Date(year,month+1,0,23,59,59).toISOString();
    const r=await fetch(`/api/gcal/events?calendarId=primary&timeMin=${encodeURIComponent(timeMin)}&timeMax=${encodeURIComponent(timeMax)}`).then(r=>r.json()).catch(()=>({success:false}));
    if(r.success&&r.data) setEvents(r.data.map(e=>({...e,calendarId:'primary'})));
    else setEvents([]);
    setLoading(false);
  },[currentDate]);

  // Carica tutti gli eventi (per filtro "tutti" e "passati") — ultimi 12 mesi + prossimi 12
  const loadAllEvents=useCallback(async()=>{
    const timeMin=new Date(new Date().getFullYear()-1,0,1).toISOString();
    const timeMax=new Date(new Date().getFullYear()+1,11,31).toISOString();
    const r=await fetch(`/api/gcal/events?calendarId=primary&timeMin=${encodeURIComponent(timeMin)}&timeMax=${encodeURIComponent(timeMax)}`).then(r=>r.json()).catch(()=>({success:false}));
    if(r.success&&r.data) setAllEvents(r.data.map(e=>({...e,calendarId:'primary'})));
  },[]);

  useEffect(()=>{
    checkAuth().then(ok=>{if(ok){loadCalendars();}else setLoading(false);});
    if(window.location.search.includes('gcal=ok')){window.history.replaceState({},'','/');showToast('Google Calendar connesso ✓','success');}
  },[checkAuth,loadCalendars]);

  useEffect(()=>{if(connected){loadMonthEvents();loadAllEvents();}}, [connected,loadMonthEvents,loadAllEvents]);

  const handleSave=async({id,summary,date,startTime,endTime,location,description})=>{
    const event={summary,start:{dateTime:`${date}T${startTime}:00`,timeZone:'Europe/Rome'},end:{dateTime:`${date}T${endTime}:00`,timeZone:'Europe/Rome'},location,description};
    setModal(null);showToast(id?'Salvataggio…':'Creazione…');
    const r=id
      ?await fetch(`/api/gcal/events/${id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(event)}).then(r=>r.json())
      :await fetch('/api/gcal/events',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(event)}).then(r=>r.json());
    if(r.success){showToast(id?'Aggiornato ✓':'Creato ✓','success');loadMonthEvents();loadAllEvents();}
    else showToast('Errore: '+(r.error||'operazione fallita'),'error');
  };

  const handleDelete=async(evId)=>{
    const ev=events.find(e=>e.id===evId)||allEvents.find(e=>e.id===evId);
    setModal(null);showToast('Eliminazione…');
    const r=await fetch(`/api/gcal/events/${evId}?calendarId=${encodeURIComponent(ev?.calendarId||'primary')}`,{method:'DELETE'}).then(r=>r.json());
    if(r.success){showToast('Eliminato','success');loadMonthEvents();loadAllEvents();}
    else showToast('Errore','error');
  };

  // Filtra eventi per la lista
  const filteredEvents=()=>{
    const now=new Date(); now.setHours(0,0,0,0);
    const pool=filter==='all'||filter==='past'?allEvents:events;
    let list=[...pool].sort((a,b)=>evDate(a)-evDate(b));
    if(filter==='7d'){
      const end=new Date(now); end.setDate(end.getDate()+7); end.setHours(23,59,59,999);
      list=list.filter(e=>{const d=evDate(e);return d>=now&&d<=end;});
    } else if(filter==='past'){
      list=list.filter(e=>evDate(e)<now).reverse();
    }
    return list;
  };

  const monthLabel=currentDate.toLocaleDateString('it-IT',{month:'long',year:'numeric'});
  const today=new Date(); today.setHours(0,0,0,0);

  const renderMiniCal=()=>{
    const year=currentDate.getFullYear(),month=currentDate.getMonth();
    const firstDay=new Date(year,month,1).getDay(),daysInMonth=new Date(year,month+1,0).getDate();
    const startOffset=firstDay===0?6:firstDay-1;
    const prevDays=new Date(year,month,0).getDate();
    const cells=[];
    for(let i=startOffset-1;i>=0;i--) cells.push({day:prevDays-i,other:true});
    for(let d=1;d<=daysInMonth;d++) cells.push({day:d,other:false});
    const rem=(7-cells.length%7)%7;
    for(let i=1;i<=rem;i++) cells.push({day:i,other:true});
    return (
      <div style={{padding:'8px 10px 6px',flexShrink:0}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
          <button onClick={()=>setCurrentDate(d=>new Date(d.getFullYear(),d.getMonth()-1,1))} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text-muted)',fontSize:14,padding:'0 4px'}}>‹</button>
          <span style={{fontSize:11,fontWeight:600,color:'var(--text)',textTransform:'capitalize'}}>{monthLabel}</span>
          <button onClick={()=>setCurrentDate(d=>new Date(d.getFullYear(),d.getMonth()+1,1))} style={{background:'none',border:'none',cursor:'pointer',color:'var(--text-muted)',fontSize:14,padding:'0 4px'}}>›</button>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',marginBottom:2}}>
          {['L','M','M','G','V','S','D'].map((d,i)=>(
            <div key={i} style={{textAlign:'center',fontSize:9,fontWeight:600,color:i>=5?'var(--c-red)':'var(--text-faint)',padding:'2px 0'}}>{d}</div>
          ))}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:1}}>
          {cells.map((cell,idx)=>{
            const cellDate=new Date(year,month,cell.day);
            const isToday=!cell.other&&sameDay(cellDate,today);
            const isSel=selectedDay&&!cell.other&&sameDay(cellDate,selectedDay);
            const holiday=!cell.other&&isHoliday(cellDate);
            const saturday=!cell.other&&isSaturday(cellDate);
            const dayEvs=cell.other?[]:events.filter(e=>sameDay(evDate(e),cellDate));
            return (
              <div key={idx}
                onClick={()=>{if(!cell.other){const d=new Date(year,month,cell.day);setSelectedDay(isSel?null:d);}}}
                style={{display:'flex',flexDirection:'column',alignItems:'center',padding:'2px 0',cursor:cell.other?'default':'pointer',borderRadius:4,background:isSel?'var(--accent)':isToday?'var(--accent-light)':'transparent',opacity:cell.other?0.3:1,transition:'background 0.1s'}}>
                <span style={{fontSize:10,fontWeight:isToday||isSel?700:400,lineHeight:1.6,color:isSel?'#fff':isToday?'var(--accent)':holiday?'var(--c-red)':saturday?'#e57373':'var(--text)'}}>{cell.day}</span>
                {dayEvs.length>0&&<span style={{width:3,height:3,borderRadius:'50%',background:isSel?'#fff':getColor(dayEvs[0],calendars),marginTop:1}}/>}
              </div>
            );
          })}
        </div>
        <div style={{display:'flex',gap:10,marginTop:5,fontSize:9,color:'var(--text-faint)'}}>
          <span style={{color:'var(--c-red)',fontWeight:500}}>● Dom/Festivi</span>
          <span style={{color:'#e57373',fontWeight:500}}>● Sabato</span>
        </div>
      </div>
    );
  };

  const listed=filteredEvents();

  if(!connected&&!loading) return (
    <div style={{position:'fixed',right:0,top:'50%',transform:'translateY(-50%)',zIndex:50}}>
      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRight:'none',borderRadius:'8px 0 0 8px',padding:'12px 8px',display:'flex',flexDirection:'column',alignItems:'center',gap:6,boxShadow:'-2px 0 8px rgba(0,0,0,0.08)'}}>
        <span style={{fontSize:18}}>📅</span>
        <a href="/api/auth/google" style={{fontSize:9,color:'var(--accent)',textDecoration:'none',fontWeight:600,writingMode:'vertical-rl'}}>Connetti</a>
      </div>
    </div>
  );

  return (
    <>
      {/* Tab laterale */}
      <div style={{position:'fixed',right:expanded?280:0,top:'50%',transform:'translateY(-50%)',zIndex:51,transition:'right 0.3s ease'}}>
        <button onClick={()=>setExpanded(e=>!e)} style={{background:'var(--surface)',border:'1px solid var(--border)',borderRight:'none',borderRadius:'8px 0 0 8px',padding:'12px 6px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:4,boxShadow:'-2px 0 8px rgba(0,0,0,0.08)',color:'var(--text)'}}>
          <span style={{fontSize:14}}>📅</span>
          <span style={{fontSize:8,fontWeight:600,color:'var(--text-faint)',writingMode:'vertical-rl'}}>{expanded?'CHIUDI':'CAL'}</span>
        </button>
      </div>

      {/* Pannello laterale */}
      <div style={{position:'fixed',right:expanded?0:-300,top:0,width:280,height:'100vh',background:'var(--surface)',borderLeft:'1px solid var(--border)',boxShadow:'-4px 0 16px rgba(0,0,0,0.08)',zIndex:50,transition:'right 0.3s ease',display:'flex',flexDirection:'column'}}>

        {/* Header */}
        <div style={{padding:'12px 10px 8px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <span style={{fontSize:12,fontWeight:600,color:'var(--text)'}}>📅 Google Calendar</span>
          <div style={{display:'flex',gap:4}}>
            <button className="btn btn-sm" style={{fontSize:10,padding:'2px 6px'}} onClick={()=>{loadMonthEvents();loadAllEvents();}}>↺</button>
            <button className="btn btn-primary btn-sm" style={{fontSize:10,padding:'2px 8px'}} onClick={()=>setModal({type:'new',data:{}})}>+ Evento</button>
          </div>
        </div>

        {loading?(
          <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--text-faint)',fontSize:12}}>⏳ Caricamento…</div>
        ):(
          <div style={{display:'flex',flexDirection:'column',height:'100%',overflow:'hidden'}}>

            {/* Mini calendario */}
            {renderMiniCal()}

            {/* Pannello giorno selezionato */}
            {selectedDay&&(
              <DayPanel date={selectedDay} events={events} calendars={calendars}
                onClose={()=>setSelectedDay(null)}
                onNew={()=>{const ds=`${selectedDay.getFullYear()}-${String(selectedDay.getMonth()+1).padStart(2,'0')}-${String(selectedDay.getDate()).padStart(2,'0')}`;setModal({type:'new',data:{date:ds}});}}
                onEdit={ev=>setModal({type:'edit',data:ev})}/>
            )}

            {/* Lista eventi con filtri */}
            {!selectedDay&&(
              <>
                <div style={{borderTop:'1px solid var(--border)',padding:'8px 10px 6px',flexShrink:0}}>
                  {/* Filtri */}
                  <div style={{display:'flex',gap:4,marginBottom:2}}>
                    {FILTERS.map(f=>(
                      <button key={f.key} onClick={()=>setFilter(f.key)}
                        style={{flex:1,padding:'4px 0',fontSize:10,fontWeight:filter===f.key?600:400,borderRadius:5,border:'1px solid var(--border)',background:filter===f.key?'var(--accent)':'transparent',color:filter===f.key?'#fff':'var(--text-muted)',cursor:'pointer',transition:'all 0.15s'}}>
                        {f.label}
                      </button>
                    ))}
                  </div>
                </div>

                <div style={{flex:1,overflowY:'auto',padding:'0 10px 16px'}}>
                  {listed.length===0?(
                    <div style={{textAlign:'center',padding:'20px 0',color:'var(--text-faint)',fontSize:11}}>Nessun evento</div>
                  ):listed.map(e=>{
                    const col=getColor(e,calendars);
                    const dt=evDate(e);
                    const now=new Date(); now.setHours(0,0,0,0);
                    const isPast=dt<now;
                    const isToday2=sameDay(dt,today);
                    const dayLabel=isToday2?'Oggi':dt.toLocaleDateString('it-IT',{weekday:'short',day:'numeric',month:'short'});
                    return (
                      <div key={e.id} onClick={()=>setModal({type:'edit',data:e})}
                        style={{display:'flex',gap:7,padding:'5px 6px',borderRadius:5,marginBottom:3,cursor:'pointer',background:'var(--bg)',border:'1px solid var(--border)',opacity:isPast&&filter!=='past'?0.6:1}}>
                        <div style={{width:3,borderRadius:2,background:col,flexShrink:0,alignSelf:'stretch'}}/>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:11,fontWeight:500,color:'var(--text)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',textDecoration:isPast&&filter==='past'?'none':'none'}}>{e.summary}</div>
                          <div style={{fontSize:10,color:'var(--text-faint)',marginTop:1}}>
                            <span style={{color:isToday2?'var(--accent)':'var(--text-muted)',fontWeight:isToday2?600:400}}>{dayLabel}</span>
                            {e.start?.dateTime&&<span> · {fmtTime(e)}</span>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {modal?.type==='new'&&<EventoModal evento={modal.data} onClose={()=>setModal(null)} onSave={handleSave} onDelete={handleDelete}/>}
      {modal?.type==='edit'&&<EventoModal
        evento={{id:modal.data.id,summary:modal.data.summary,date:modal.data.start?.date||new Date(modal.data.start?.dateTime).toISOString().split('T')[0],startTime:modal.data.start?.dateTime?new Date(modal.data.start.dateTime).toTimeString().slice(0,5):'09:00',endTime:modal.data.end?.dateTime?new Date(modal.data.end.dateTime).toTimeString().slice(0,5):'10:00',location:modal.data.location||'',description:modal.data.description||''}}
        onClose={()=>setModal(null)} onSave={handleSave} onDelete={handleDelete}/>}

      {toast&&<div style={{position:'fixed',bottom:20,left:'50%',transform:'translateX(-50%)',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:'8px 14px',fontSize:12,color:'var(--text)',zIndex:999,boxShadow:'0 2px 12px rgba(0,0,0,0.12)',display:'flex',alignItems:'center',gap:6,whiteSpace:'nowrap'}}>
        {toast.type==='success'?'✅':toast.type==='error'?'❌':'ℹ️'} {toast.msg}
      </div>}
    </>
  );
}
